export default __webpack_public_path__ + "static/media/man_with_phone.99961d54.png";